import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

export interface ArcheidosKeyType {
  archeidos: LocalesKey;
  characterEnchancer: LocalesKey;
  completed: LocalesKey;
  generalEnchancer: LocalesKey;
  generationStarted: LocalesKey;
  lockStrength: LocalesKey;
  originalRetention: LocalesKey;
  prompt: LocalesKey;
  seed: LocalesKey;
  sourceImage: LocalesKey;
  steps: LocalesKey;
  styleTransfer: LocalesKey;
  transfersTheVisualStyleFromOneImageToAnotherWhilePreservingTheContentAndCompositionOfTheOriginalImageIdealForApplyingaSpecificColorSchemeLightingOrArtisticStyle: LocalesKey;
}

export const archeidosKeys = keyPathMirror<ArcheidosKeyType, string>(
  {
    archeidos: null,
    characterEnchancer: null,
    completed: null,
    generalEnchancer: null,
    generationStarted: null,
    lockStrength: null,
    originalRetention: null,
    prompt: null,
    seed: null,
    sourceImage: null,
    steps: null,
    styleTransfer: null,
    transfersTheVisualStyleFromOneImageToAnotherWhilePreservingTheContentAndCompositionOfTheOriginalImageIdealForApplyingaSpecificColorSchemeLightingOrArtisticStyle:
      null
  },
  'models.archeidos.'
);
